module.exports = __webpack_public_path__ + "static/media/bg_page9.7976a84a.jpg";